import React from 'react';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';

import './style.scss';

const TRANSLATION_KEY = 'PowerSupply.string';

/**
 * Default:
 *    Renders tooltip when not hovering over component
 */
export function Default() {
  const {
    t,
    //i18l
  } = useTranslation();
  const TEXT = t(TRANSLATION_KEY);

  return <div className='ps_tooltip_default'>{TEXT}</div>;
}

Default.propTypes = {};
